module.exports = __webpack_public_path__ + "img/art1.aabb4adf.png";